import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Button from '@telia-front/button';
import Card, { CardContent } from '@telia-front/card';
import CloseButton from '@telia-front/close-button';
import { Container } from '@telia-front/container';
import Grid, { GridColumn } from '@telia-front/grid';
import { HeaderContext } from '@telia-front/header-provider';
import { isScrollDisabled } from '@telia-front/helper';
import { Image } from '@telia-front/image';
import { useLabels } from '@telia-front/label-provider';
const COMPARISON_PRODUCTS_AMOUNT = 4;
const ProductComparisonBar = (props) => {
    const { products, compareButton, resetButton, headingText } = props;
    const labels = useLabels();
    const [hasScrolled, setHasScrolled] = React.useState(false);
    const [comparisonBarHeight, setComparisonBarHeight] = React.useState(0);
    const comparisonProducts = products.slice(0, 4);
    const numberOfEmptySlots = COMPARISON_PRODUCTS_AMOUNT - comparisonProducts.length;
    const element = React.useRef(null);
    const { headerHeight, isHeaderHidden, headerBottomHeight } = React.useContext(HeaderContext);
    React.useEffect(() => {
        var _a;
        const handleScroll = () => {
            var _a, _b, _c;
            if (!isScrollDisabled()) {
                const salesArgumentsBarHeight = ((_a = document.querySelector('.carousel--sales-argument')) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
                const scrollTop = Math.ceil(window.scrollY || ((_b = document.documentElement) === null || _b === void 0 ? void 0 : _b.scrollTop) || 0);
                setHasScrolled(scrollTop >= salesArgumentsBarHeight);
            }
            if (((_c = element.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== undefined) {
                setComparisonBarHeight(element.current.clientHeight);
            }
        };
        if (((_a = element.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== undefined) {
            setComparisonBarHeight(element.current.clientHeight);
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const BEM = () => {
        const classArray = ['product-comparison-bar'];
        if (hasScrolled) {
            classArray.push('has-scrolled');
        }
        return classArray.join(' ');
    };
    const renderButtons = () => (React.createElement(GridColumn, { width: ['max-lg'], border: ['left-lg'], className: "product-comparison-bar__slot product-comparison-bar__buttons" },
        React.createElement(Grid, { align: ['middle-xs', 'between-xs'], verticalGutter: "xsmall", reverse: ['xs'] },
            React.createElement(GridColumn, { width: ['xs', 'max-lg'], className: "text-center" },
                React.createElement(Button, Object.assign({}, compareButton, { size: "small", iconLeft: "#compare" }))),
            React.createElement(GridColumn, { width: ['xs', 'max-lg'], className: "text-center text-small" },
                React.createElement(Button, Object.assign({}, resetButton, { link: true }))))));
    const renderEmptySlots = () => Array.from(Array(numberOfEmptySlots).keys()).map(({}, index) => (React.createElement(GridColumn, { key: `product-comparison-bar-empty-slot-${index}`, width: ['xs-3', 'max-lg'], border: ['left-xs'], className: "product-comparison-bar__slot", "aria-hidden": true },
        React.createElement(Grid, null,
            React.createElement(GridColumn, { className: "text-center text-inactive h3", align: ['middle-xs'] }, comparisonProducts.length + index + 1)))));
    const renderContent = (product) => {
        const contentElement = (React.createElement(Grid, { noWrap: true, align: ['middle-xs', 'center-xs'], horizontalGutter: "small", gutter: "none" },
            React.createElement(GridColumn, { width: ['min'], className: "product-comparison-bar__product-image-wrapper" },
                React.createElement("div", { className: "product-comparison-bar__product-image-container" },
                    React.createElement(Image, Object.assign({}, product.image, { width: 48, shape: "rounded" })))),
            React.createElement(GridColumn, { width: ['max'], className: "product-comparison-bar__product-name" },
                React.createElement("strong", { className: "text-small" }, product.name))));
        if (product.url) {
            return (React.createElement(Anchor, { url: product.url, onClick: product.onClick, isTextColor: true, isUnderlined: false, className: "product-comparison-bar-anchor" }, contentElement));
        }
        return contentElement;
    };
    const renderProducts = () => comparisonProducts.map((product, index) => (React.createElement(GridColumn, { key: `product-comparison-bar-product-${index}`, width: ['xs-3', 'max-lg'], border: index !== 0 ? ['left-xs'] : undefined, className: "product-comparison-bar__slot" },
        React.createElement(Grid, { noWrap: true, align: ['middle-xs', 'center-xs'], horizontalGutter: "small", className: "product-comparison-bar__content-wrapper" },
            React.createElement(GridColumn, { width: ['min-xs', 'max-lg'] }, renderContent(product)),
            React.createElement(GridColumn, { width: ['min'], className: "product-comparison-bar__close-button" },
                React.createElement(CloseButton, { type: "modal", onClick: product.onRemove, label: `${labels.get('remove')} - ${product.name}` }))))));
    if (!products.length) {
        return null;
    }
    const getStyle = () => {
        return {
            top: headerHeight - (isHeaderHidden ? headerBottomHeight : 0),
        };
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: BEM(), ref: element, style: getStyle() },
            React.createElement(Card, { className: "product-comparison-bar__card", elevation: 1 },
                React.createElement(CardContent, { padding: {
                        top: 'small',
                        right: 'none',
                        bottom: 'small',
                        left: 'none',
                    } },
                    React.createElement(Container, null,
                        React.createElement("p", { className: "sr-only" }, headingText || labels.get('productComparisonBar.heading')),
                        React.createElement(Grid, { borderWeight: "thin", align: ['around-lg'], verticalGutter: "small", className: "product-comparison-bar__grid", equalHeight: true },
                            renderProducts(),
                            renderEmptySlots(),
                            renderButtons()))))),
        React.createElement("div", { className: "product-comparison-bar__background", style: { height: comparisonBarHeight }, "aria-hidden": true })));
};
export default ProductComparisonBar;
